module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/home/home-tab/home-tab.component.scss
// module id = ./src/app/entities/home/home-tab/home-tab.component.scss
// module chunks = main